@if (showPetCards) {
  <div class="container" [@slideInOut]>
    <div class="card-carousel" #cardCarousel (touchstart)="startTouch($event)" (touchmove)="moveTouch($event)"
      (touchend)="endTouch()" (touchcancel)="endTouch()">
      @for (pet of pets; track pet; let i = $index) {
        <div class="pet-card" [attr.data-step]="i">
          <div class="pet-card-flipper" [class.flipped]="flipCard && activeStep===i" (click)="cardClicked()">
            <div class="pet-card-front">
              <cpf-pet-card [petInfo]="pet" [showSubmitButton]="true"
              (actionButtonClickEmitter)="cardAction()"></cpf-pet-card>
            </div>
            <div class="pet-card-back">
              <cpf-insurance-card [pet]="pet"></cpf-insurance-card>
            </div>
          </div>
        </div>
      }
      <div class="pet-card bg-white">
        <button class="button primary" (click)="openClosingPage()">{{'pet-carousel.buy-insurance-button'| translate}}</button>
      </div>
    </div>
    <div class="flip-hint">
      <p class="subtitle-12">{{ 'pet-carousel.flip-hint' | translate }}</p>
    </div>
    <div class="step-indicator-container">
      <div class="steps">
        @for (pet of pets; track pet; let i = $index) {
          <div class="step" [class.active]="activeStep===i"
          (click)="selectStep(i)"></div>
        }
      </div>
    </div>
  </div>
}
